var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"sctAvatar\" ng-style=\"{ background: vm.color, color: vm.texColor }\" title=\"{{ ::vm.profileName(vm.profile) }}\">\n<img ng-if=\"vm.profile.AvatarUrl\" ng-src=\"{{ vm.profile.AvatarUrl }}\">\n<span ng-if=\"!vm.profile.AvatarUrl\">{{ vm.initials }}</span>\n</div>";
var id1="sct/sctAvatar/sctAvatar.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/sct/sctAvatar/sctAvatar.html
// module id = 1280
// module chunks = 1